import React from 'react'
import MopraIcon from '@material-ui/icons/Spa'
import LandDeformationIcon from '@material-ui/icons/LocationCity'
import RiverIceIcon from '@material-ui/icons/DirectionsBoat'
import SmartIceIcon from '@material-ui/icons/AcUnit'
import PolarViewIcon from '@material-ui/icons/RemoveRedEye'
import InlandWatersIcon from '@material-ui/icons/Pool'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import { smartIceLocations, arcticCrowdSourceLocations } from './locations'
import * as legends from './legends'
import { getBrand } from '../selectors/brandSelector'
import * as serviceObject from '../services/'

export const POLAR_VIEW = getBrand() === 'PolarView'
// export const POLAR_VIEW = true
export const ICE_DRIFT_BRAND = getBrand() === 'IceDrift'
// export const ICE_DRIFT_BRAND = true


const SENTINEL_KEY = '6179cd9a-6ff5-43a5-8f01-8aef07e9f211'

export const SMARTICE = '//geoserver.looknorthservices.com/geoserver/coresight2/'
// export const GET_CAPABILITIES = token =>
//   `//geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetCapabilities&version=1.1.1&token=${token}`
export const GET_CAPABILITIES = token =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetCapabilities&version=1.1.1&token=${token}`

export const GET_CAPABILITIES_CMEM =
  'https://thredds.met.no/thredds/wms/sea_ice/SIW-DMI-ARC-SEAICE_HR-OBS/ice_conc_greenland_overview_aggregated?&service=WMS&request=GetCapabilities&styles=&version=1.1.1'

export const CMEMS_WMS = `https://thredds.met.no/thredds/wms/sea_ice/SIW-DMI-ARC-SEAICE_HR-OBS/ice_conc_greenland_overview_aggregated?service=WMS&request=GetFeatureInfo&QUERY_LAYERS=ice_concentration&bbox=-7983694.730330089,11584184.510675032,-7827151.696402049,11740727.544603072&version=1.1.1&srs=CRS:84&width=512&height=512&x=256&y=256&INFO_FORMAT=text/html&exceptions=application%2Fvnd.ogc.se_xml&styles&layers=ice_concentration`

export const GET_LAYERS = token =>
  `https://geoserver.looknorthservices.com/geoserver/rest/workspaces/coresight2/featuretypes.json`

export const ICE_DRIFT = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:IceDrift&styles=&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

// export const ICE_DRIFT = ({ idToken, timeIso }) =>
//   `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:IceDriftS1&styles=&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&transparent=true&tiled=true&token=${idToken}&BBOX={bbox-epsg-3857}`

export const ICE_DRIFT_VELOCITY = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:IceDriftVelocity&styles=&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

export const ICE_DRIFT2 = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:IceDrift2&styles=&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

export const WATER_TEMPERATURE = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:WaterTemperatureWMS&styles=&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

export const WATER_SEDIMENT = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:WaterSedimentWMS&styles=&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

export const WATER_LAKE_CHL = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:WaterLakeChl&styles=&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

export const WATER_LAKE_TSS = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:WaterLakeTss&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

export const WATER_LAKE_TSS_VECTOR = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/WaterLakeTss/{z}/{x}/{y}`

export const LAKE_TSS_VECTOR = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/LakeTss/{z}/{x}/{y}.pbf`

export const WATER_RIVER_SSC = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:WaterRiverSsc&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng8&transparent=true&tiled=true&TIME=${encodeURIComponent(
    timeIso
  )}&token=${idToken}&BBOX={bbox-epsg-3857}`

export const SMART_ICE = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ASmartIceMaps&styles=&format=image%2Fpng8&transparent=true&tiled=true&minTime=Tue%20Feb%2021%202017%2009%3A09%3A34%20GMT-0330%20(NST)&maxTime=Sun%20May%2004%202025%2010%3A00%3A00%20GMT-0230%20(NDT)&height=256&width=256&srs=EPSG%3A3857&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const SMART_ICE_QAMUTIK = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ASmartIceQamutik&styles=&format=image%2Fpng8&transparent=true&tiled=true&height=256&width=256&srs=EPSG%3A3857&TIME=${encodeURIComponent(
    getDateFromTimeIso({ timeIso, min: true })
  )}%2F${encodeURIComponent(
    getDateFromTimeIso({ timeIso, max: true })
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const SMART_ICE_QAMUTIK_VECTOR = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ASmartIceQamutik&styles=&format=application%2Fx-protobuf;type=mapbox-vector&transparent=true&tiled=true&height=512&width=512&srs=EPSG%3A3857&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const POLARVIEW_APP = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3APolarviewApp&styles=&format=application%2Fx-protobuf;type=mapbox-vector&transparent=true&tiled=true&height=512&width=512&srs=EPSG%3A3857&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const RIVER_ICE = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ARiverIce&width=256&height=256&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const RIVER_ICE_VECTOR = token =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ARiverIce&width=512&height=512&srs=EPSG:3857&format=application/x-protobuf;type=mapbox-vector&transparent=true&BBOX={bbox-epsg-3857}&token=${token}`

export const LAND_DEFORMATION = token =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&version=1.1.0&request=GetMap&layers=coresight2:QueryLandDeformationRaster&styles=&width=256&height=256&srs=EPSG:4326&format=image%2Fpng8&transparent=true&token=${token}`

export const LAND_DEFORMATION_INSAR = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ALandDeformationCalifornia&width=256&height=256&srs=EPSG:3857&format=image%2Fpng8&transparent=true&BBOX={bbox-epsg-3857}&token=${idToken}&TIME=${encodeURIComponent(
    timeIso
  )}`

export const MOPRA = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AReclaimedWellsites&width=512&height=512&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const WELLSITE_NDVI_CONTROL = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AWellsiteNdviControl&width=512&height=512&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const WELLSITE_NDVI_LEASE = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AWellsiteNdviLease&width=512&height=512&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const MOPRA_VECTOR = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AReclaimedWellsites&width=512&height=512&srs=EPSG:3857&format=application/x-protobuf;type=mapbox-vector&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const SENTINEL1 = ({ timeIso, format='jpeg' }) =>
  `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_KEY}?showLogo=false&service=WMTS&request=GetMap&layers=S1-DB-HH3&styles=&format=image%2F${format}&transparent=true&version=1.1.1&time=${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}%2F${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}&name=Sentinel-1&maxcc=60&height=512&width=512&srs=EPSG%3A3857&bbox={bbox-epsg-3857}&exceptions=BLANK`

export const SENTINEL2 = ({ timeIso, format='jpeg' }) =>
  `https://services.sentinel-hub.com/ogc/wms/318be53b-974b-4918-8f5f-53ba0a37079c?showLogo=false&service=WMTS&request=GetMap&layers=TRUE_COLOR&styles=&format=image%2F${format}&transparent=true&version=1.1.1&time=${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}%2F${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}&name=Sentinel-2&maxcc=60&height=512&width=512&srs=EPSG%3A3857&bbox={bbox-epsg-3857}&exceptions=BLANK`

export const MODIS = ({ timeIso }) =>
  `https://map1a.vis.earthdata.nasa.gov/wmts-webmerc/MODIS_Terra_CorrectedReflectance_TrueColor/default/${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}/GoogleMapsCompatible_Level9/{z}/{y}/{x}.jpg`

export const CMEMS_SEA_ICE = ({ timeIso }) =>
  `https://thredds.met.no/thredds/wms/sea_ice/SIW-DMI-ARC-SEAICE_HR-OBS/ice_conc_greenland_overview_aggregated?&service=WMS&request=GetMap&layers=ice_concentration&styles=boxfill%2Frainbow&format=image%2Fpng&transparent=true&version=1.1.1&test=0.9384988124610065&COLORSCALERANGE=0%2C100&NUMCOLORBANDS=20&ABOVEMAXCOLOR=0x000000&BELOWMINCOLOR=0x000000&LOGSCALE=false&height=512&width=512&srs=EPSG%3A3857&bbox={bbox-epsg-3857}`

export const CMEMS_SNOW_THICKNESS = ({ timeIso }) =>
  `https://thredds.met.no/thredds/wms/topaz/dataset-topaz4-arc-myoceanv2-be?&service=WMS&request=GetMap&layers=hsnow&styles=boxfill%2Frainbow&format=image%2Fpng&transparent=true&version=1.1.1&test=0.021257936515129083&COLORSCALERANGE=0%2C2&NUMCOLORBANDS=20&ABOVEMAXCOLOR=0x000000&BELOWMINCOLOR=0x000000&LOGSCALE=false&height=512&width=512&srs=EPSG%3A3857&bbox={bbox-epsg-3857}`

export const COASTLINE = () =>
  `https://gibs.earthdata.nasa.gov/wmts/epsg3857/best/Coastlines/default/GoogleMapsCompatible_Level9/{z}/{y}/{x}.png`

export const INFRASTRUCTURE_PIPELINE = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AInfrastructurePipelineWMS&width=256&height=256&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

export const INFRASTRUCTURE_PIPELINE_VECTOR = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/InfrastructurePipeline/{z}/{x}/{y}`

// export const INFRASTRUCTURE = ({ idToken, timeIso }) =>
//   `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AInfrastructureData&token=${idToken}`
export const INFRASTRUCTURE = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/Infrastructure/{z}/{x}/{y}`

export const BRIGGS_ICE_DEPTH = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/BriggsIceDepth/{z}/{x}/{y}`

export const BRIGGS_ICE = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/BriggsIce/{z}/{x}/{y}`

export const BRIGGS_ICE_TYPE = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/BriggsIceType/{z}/{x}/{y}`

export const RIVER_ICE_MARKERS = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/RiverIceMarkers/{z}/{x}/{y}`

export const EXPLOITS_MARKERS = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/ExploitsMarkers/{z}/{x}/{y}`

// export const SENTINEL2_RASTER = ({ idToken, timeIso }) =>
//   `https://coresight-raster.s3-us-west-2.amazonaws.com/20180402/{z}/{x}/{y}.png`

export const SENTINEL2_RASTER = ({ timeIso }) =>
  `https://services.sentinel-hub.com/ogc/wms/f41940fe-94cf-4d4c-b449-e532dca14441?showLogo=false&service=WMTS&request=GetMap&layers=TRUE_COLOR&styles=&format=image%2Fpng&transparent=true&version=1.1.1&time=${encodeURIComponent(
    getDateFromTimeIso(timeIso)
  )}%2F${encodeURIComponent(
    getDateFromTimeIso(timeIso+8.64e+7)
  )}&name=Sentinel-2&maxcc=&height=512&width=512&srs=EPSG%3A3857&bbox={bbox-epsg-3857}&exceptions=BLANK`

export const getCapabilitiesUrl = (wmsService, token) => {
  const {
    baseUrl,
    service = 'WMS',
    request = 'GetCapabilities',
    version = '1.1.1'
  } = wmsService

  const url = `${baseUrl}?service=${service}&request=${request}&version=${version}&token=${token}`

  return url
}

export const getTimestampsUrl = (wmsService, token) => {
  const {
    baseUrl,
    service = 'WMS',
    request = 'GetCapabilities',
    version = '1.1.1'
  } = wmsService

  const url = `${baseUrl}?service=${service}&request=${request}&version=${version}&token=${token}`

  return url
}

export const greenlandIce = {
  baseUrl:
    'https://thredds.met.no/thredds/wms/sea_ice/SIW-DMI-ARC-SEAICE_HR-OBS/ice_conc_greenland_overview_aggregated'
}

export const smartIce = {
  baseUrl: 'https://geoserver.looknorthservices.com/geoserver/coresight2/wms'
}

export const layers = [
  {
    baseUrl: 'https://geoserver.looknorthservices.com/geoserver/coresight2/wms',
    workspace: 'coresight2',
    name: 'RiverIce',
    timeUrl:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:RiverIceTimeMV&maxFeatures=50&outputFormat=application%2Fjson',
    timesAvailable: [],
    time: null,
    height: 256,
    width: 256,
    format: 'image/png8',
    srs: 'EPSG:3857',
    service: 'WMS',
    request: 'GetMap',
    version: '1.1.1'
  },
  {
    baseUrl: 'https://geoserver.looknorthservices.com/geoserver/coresight2/wms',
    workspace: 'coresight2',
    name: 'SmartIce',
    timeUrl:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:QuerySmartIceRasterSummary&maxFeatures=50&outputFormat=application%2Fjson',
    timesAvailable: [],
    time: null,
    height: 256,
    width: 256,
    format: 'image/png8',
    srs: 'EPSG:3857',
    service: 'WMS',
    request: 'GetMap',
    version: '1.1.1'
  },
  {
    baseUrl: 'https://geoserver.looknorthservices.com/geoserver/coresight2/wms',
    workspace: 'coresight2',
    name: 'LandDeformation',
    timeUrl:
      'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:QueryLandDeformationDistinctTimestamps&maxFeatures=50&outputFormat=application%2Fjson',
    timesAvailable: [],
    time: null,
    height: 256,
    width: 256,
    format: 'image/png8',
    srs: 'EPSG:3857',
    service: 'WMS',
    request: 'GetMap',
    version: '1.1.1'
  }
]

const services = ICE_DRIFT_BRAND ? [
    {
    name: 'IceDrift',
    label: 'Ice Drift',
    permissionId: 'iceDrift',
    iconComponent: 'SmartIce',
    showCoordinates: true,
    data: [],
    layers: [
      {
        name: 'IceDrift',
        label: 'Ice Drift',
        url: ICE_DRIFT,
        opacity: 'raster-opacity',
        datetimeId: 'IceDrift'
      },
      {
        name: 'IceDriftVelocity',
        label: 'Ice Velocity',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftVelocity'
      },
      {
        name: 'IceDriftDeformation',
        label: 'Ice Deformation',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformation'
      },
      {
        name: 'IceDriftDirection',
        label: 'Ice Direction',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDirection'
      },
      {
        name: 'IceDriftMagnitude',
        label: 'Ice Magnitude',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftMagnitude'
      },
      {
        name: 'IceDriftDeformationShear',
        label: 'Ice Deformation Shear',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformationShear'
      },
      {
        name: 'Sentinel1SixMonth',
        label: 'Sentinel 1 (75 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1SixMonth',
        secondary: true
      },
      {
        name: 'Sentinel2SixMonth',
        label: 'Sentinel 2 (10 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2SixMonth',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis (250 m)',
        url: MODIS,
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      }
    ],
    locations: [
      {
        name: 'IceDrift',
        label: 'Ice Drifit',
        latitude: 72.72476,
        longitude: -74.6495,
        zoom: [6]
      }
    ]
  },
  {
    name: 'IceDriftDev',
    label: 'Ice Drift Dev',
    permissionId: 'iceDriftDev',
    iconComponent: 'SmartIce',
    showCoordinates: true,
    data: [],
    layers: [
      {
        name: 'IceDrift',
        label: 'Ice Drift',
        url: ICE_DRIFT,
        opacity: 'raster-opacity',
        datetimeId: 'IceDrift'
      },
      {
        name: 'IceDriftVelocity',
        label: 'Ice Velocity',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftVelocity'
      },
      {
        name: 'IceDriftDeformation',
        label: 'Ice Deformation',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformation'
      },
      {
        name: 'IceDriftDirection',
        label: 'Ice Direction',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDirection'
      },
      {
        name: 'IceDriftMagnitude',
        label: 'Ice Magnitude',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftMagnitude'
      },
      {
        name: 'IceDriftDeformationShear',
        label: 'Ice Deformation Shear',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformationShear'
      },
      {
        name: 'IceDriftDeformationVorticity',
        label: 'Ice Deformation Vorticity',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformationVorticity'
      },
      {
        name: 'Sentinel1SixMonth',
        label: 'Sentinel 1 (75 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1SixMonth',
        secondary: true
      },
      {
        name: 'Sentinel2SixMonth',
        label: 'Sentinel 2 (10 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2SixMonth',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis (250 m)',
        url: MODIS,
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      }
    ],
    locations: [
      {
        name: 'IceDrift',
        label: 'Ice Drifit',
        latitude: 72.72476,
        longitude: -74.6495,
        zoom: [6]
      }
    ]
  }
]
      : POLAR_VIEW ? [
        {
    name: 'PolarView',
    authId: 'SmartIce',
          label: 'Polar View',
          logo: 'PolarView',
          iconComponent: 'PolarView',
          disableCoordinates: true,
          weather: true,
          hideDatetimeSlider: true,
    data: [],
    datetimeUrls: [
      {
        id: 'SmartIce',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceMapsAreaBounds&maxFeatures=50&outputFormat=application%2Fjson'
      },
      {
        id: 'SmartIceQamutik',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceQamutikAreaBounds&maxFeatures=50&outputFormat=application%2Fjson'
      },
      {
        id: 'Sentinel1',
        url:
          'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&time=2017-12-16%2F2018-01-15&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A4326&bbox=-90%2C-90%2C0%2C0&service=WFS',
        type: 'bbox'
      }
    ],
    layers: [
      {
        name: 'SmartIce',
        label: 'Ice travel',
        url: SMART_ICE,
        opacity: 'raster-opacity',
        datetimeId: 'SmartIce',
        legend: {
          type: 'categorical',
          data: POLAR_VIEW ? legends.polarViewLegend : legends.smartIceLegend
        }
      },
      // {
      //   name: 'PolarviewApp',
      //   label: 'Events',
      //   opacity: 'circle-opacity',
      //   // datetimeId: 'SmartIce',
      // },
      {
        name: 'Sentinel1',
        label: 'Sentinel 1 (75 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1',
        secondary: true
      },
      {
        name: 'Sentinel2',
        label: 'Sentinel 2 (10 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis (250 m)',
        url: MODIS,
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      },
      {
        name: 'CmemsSeaIce',
        label: 'Sea Ice Fraction',
        url: CMEMS_SEA_ICE,
        opacity: 'raster-opacity',
        datetimeId: 'CmemsSeaIce',
        secondary: true,
        legend: {
          type: 'categorical',
          data: legends.cmemsSeaIceLegend
        }
      },
      {
        name: 'CmemsSnowThickness',
        label: 'Snow Thickness',
        url: CMEMS_SNOW_THICKNESS,
        opacity: 'raster-opacity',
        datetimeId: 'CmemsSnowThickness',
        secondary: true,
        legend: {
          type: 'categorical',
          data: legends.cmemsSnowThicknessLegend
        }
      },
      {
        name: 'CmemsSurfaceTemperature',
        label: 'Surface Temperature',
        url: CMEMS_SNOW_THICKNESS,
        opacity: 'raster-opacity',
        datetimeId: 'CmemsSurfaceTemperature',
        secondary: true,
        legend: {
          type: 'categorical',
          data: legends.cmemsSnowThicknessLegend
        }
      },
      {
        name: 'Coastline',
        label: 'Coastline',
        url: COASTLINE,
        opacity: 'raster-opacity'
      }
    ],
    locations: [
      {
        name: 'Clyde River',
        latitude: 70.35,
        longitude: -69.7,
        maxBounds: [[-78.5, 71], [-60.5, 69]],
        zoom: [7]
      },
      {
        name: 'Qaanaaq',
        latitude: 77.41,
        longitude: -69.79,
        maxBounds: [[-90, 72], [-51, 83]],
        zoom: [6]
      },
      {
        name: 'Utqiaġvik',
        latitude: 71.30783606806223,
        longitude: -156.785888671875,
        maxBounds: [[-175, 65], [-140, 76]],
        zoom: [6]
      },
      {
        name: 'Yellowknife',
        latitude: 62.442222,
        longitude: -114.3975,
        maxBounds: [[-120, 59], [-108, 66]],
        zoom: [6]
      }
    ]
  }
      ]
      :
      [
        ...Object.values(serviceObject),
    {
    name: 'Mopra',
    label: 'Wellsite Reclamation Legacy',
    authId: 'ReclaimedWellsites',
      permissionId: 'ReclaimedWellsites',
      upload: false,
    description: '',
      iconComponent: 'Mopra',
      multiselect: false,
      autocomplete: true,
    data: [
      {
        id: 'Mopra',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:ReclaimedWellsitesWellsiteSummary&outputFormat=application%2Fjson`,
        type: 'extent',
        active: 'active'
      },
      {
        id: 'Mopra2',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:ReclaimedWellsitesWellsiteSummary&outputFormat=application%2Fjson`,
        type: 'extent',
        active: 'active'
      }
    ],
    datetimeUrls: [
      {
        id: 'Mopra',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:ReclaimedWellsitesAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
      }
    ],
    layers: [
      {
        name: 'MopraWellsites',
        label: 'Health',
        url: MOPRA,
        opacity: 'fill-opacity',
        datetimeId: 'MopraWellsites',
        legend: {
          type: 'categorical',
          data: legends.mopraWellsitesLegend
        }
      },
      {
        name: 'Mopra',
        label: 'NDVI',
        url: MOPRA,
        opacity: 'raster-opacity',
        datetimeId: 'Mopra',
        legend: {
          type: 'categorical',
          data: legends.mopraLegend
        }
      },
      {
        name: 'WellsiteRank',
        label: 'Wellsite outliers',
        url: MOPRA,
        opacity: 'fill-opacity',
        open: true,
        datetimeId: 'WellsiteRank',
        filter: {
          min: 0,
          max: 300,
          value: 200,
          label: ' \u03C3 outlier',
          title: '',
          transform: value => value/100,
          transformIn: value => value*100,
          transformOut: value => value/100
        },
        // datetimeId: 'WellsiteNdviLease',
        // legend: {
        //   type: 'categorical',
        //   data: legends.mopraLegend
        // }
      },
      {
        name: 'WellsiteNdviLease',
        label: 'NDVI lease',
        url: MOPRA,
        opacity: 'raster-opacity',
        datetimeId: 'WellsiteNdviLease',
        legend: {
          type: 'categorical',
          data: legends.mopraLegend
        }
      },
      {
        name: 'WellsiteNdviControl',
        label: 'NDVI control',
        url: MOPRA,
        opacity: 'raster-opacity',
        datetimeId: 'WellsiteNdviControl',
        legend: {
          type: 'categorical',
          data: legends.mopraLegend
        }
      },
      {
        name: 'WellsiteEviLease',
        label: 'EVI lease',
        url: MOPRA,
        opacity: 'raster-opacity',
        datetimeId: 'WellsiteEviLease',
        legend: {
          type: 'categorical',
          data: legends.mopraLegend
        }
      },
      {
        name: 'WellsiteEviControl',
        label: 'EVI control',
        url: MOPRA,
        opacity: 'raster-opacity',
        datetimeId: 'WellsiteEviControl',
        legend: {
          type: 'categorical',
          data: legends.mopraLegend
        }
      },
      {
        name: 'Sentinel2Ndvi',
        label: 'Sentinel 2 (10 m)',
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2Ndvi',
        secondary: true
      },
      {
        name: 'MopraVector',
        label: 'Vector Detail',
        url: MOPRA_VECTOR,
        opacity: 'fill-opacity',
        datetimeId: 'Mopra'
      },
      {
        name: 'AnnualCropInventory',
        label: 'Annual crop inventory',
        url: MOPRA_VECTOR,
        opacity: 'fill-opacity'
      },
      {
        name: 'LandCover2010',
        label: 'ABMI Human Footprint',
        url: MOPRA_VECTOR,
        opacity: 'fill-opacity'
      }
    ],
      locations: [
        // 50.6207, -111.9190
      {
        name: 'BrooksAirport',
        label: 'Brooks Airport',
        latitude: 50.6207,
        longitude: -111.9190,
        // maxBounds: [[-112.5, 50], [-110.5, 51]],
        zoom: [17]
      },
      {
        name: 'LakeNewell',
        label: 'Lake Newell',
        latitude: 50.49,
        longitude: -111.993,
        // maxBounds: [[-112.5, 50], [-110.5, 51]],
        zoom: [15]
      },
        {
          name: 'BourqueLake',
          label: 'Bourque Lake',
          latitude: 54.6504,
          longitude: -110.5574,
          // maxBounds: [[-112.5, 50], [-110.5, 51]],
          zoom: [15]
        }
    ]
    },
  {
    name: 'Infrastructure',
    label: 'Infrastructure',
    iconComponent: 'LandDeformation',
    multiselect: true,
    data: [],
    layers: [
      {
        name: 'InfrastructurePipelineVector',
        label: 'Pipeline',
        url: INFRASTRUCTURE_PIPELINE_VECTOR,
        opacity: 'line-opacity',
        datetimeId: 'InfrastructurePipeline',
        disableToggle: true
      },
      {
        name: 'Infrastructure',
        label: 'Infrastructure',
        url: INFRASTRUCTURE,
        opacity: 'circle-opacity',
        datetimeId: 'Infrastructure',
        disableToggle: false
      }
    ],
    locations: [
      {
        name: 'Cochrane',
        latitude: 51.19,
        longitude: -114.49,
        zoom: [13],
        maxBounds: [[-116, 45], [-112, 56]]
      }
    ]
  },
  {
    name: 'SmartIce',
    authId: 'SmartIce',
    label: 'Smart Ice',
    iconComponent: 'SmartIce',
    logo: 'SmartIce',
    hideDatetimeSlider: true,
    disableMainDate: true,
    data: [
      {
        id: 'SmartIceQamutikPoint',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ASmartIceQamutikPoint`,
        datetimeId: 'WaterTemperature',
        type: 'point'
      },
    ],
    datetimeUrls: [
      {
        id: 'SmartIce',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceMapsAreaBounds&maxFeatures=50&outputFormat=application%2Fjson'
      },
      {
        id: 'SmartIceQamutik',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceQamutikAreaBounds&maxFeatures=50&outputFormat=application%2Fjson'
      },
      {
        id: 'Sentinel1',
        url:
          'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&time=2017-12-16%2F2018-01-15&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A4326&bbox=-90%2C-90%2C0%2C0&service=WFS',
        type: 'bbox'
      }
    ],
    layers: [
      // {
      //   name: 'SmartIce',
      //   label: 'Travel Hazard Map',
      //   url: SMART_ICE,
      //   opacity: 'raster-opacity',
      //   datetimeId: 'SmartIce',
      //   open: true,
      //   legend: {
      //     type: 'categorical',
      //     data: legends.smartIceLegend
      //   }
      // },
      // {
      //   name: 'SmartIceQamutik',
      //   label: 'SmartQAMUTIK',
      //   url: SMART_ICE_QAMUTIK,
      //   opacity: 'raster-opacity',
      //   datetimeId: 'SmartIceQamutik',
      //   legend: {
      //     type: 'categorical',
      //     data: legends.smartIceQamutikLegend
      //   }
      // },
      {
        name: 'SmartIceQamutikLineString',
        label: 'SmartQAMUTIK',
        url: SMART_ICE_QAMUTIK,
        opacity: 'raster-opacity',
        datetimeId: 'SmartIceQamutikLineString',
        open: true,
        legend: {
          type: 'categorical',
          data: legends.smartIceQamutikLegend
        }
      },
      // {
      //   name: 'SmartIceQamutikVector',
      //   label: 'Qamutik vector',
      //   url: SMART_ICE_QAMUTIK,
      //   opacity: 'line-opacity',
      //   datetimeId: 'SmartIceQamutik'
      // },
      // {
      //   name: 'Buoys',
      //   label: 'SmartBUOY',
      //   url: SMART_ICE,
      //   opacity: 'circle-opacity'
      // },
      {
        name: 'Sentinel1',
        label: 'Sentinel 1',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis',
        url: MODIS,
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      }
      // {
      //   name: 'IceDrift',
      //   label: 'Ice Drift',
      //   url: MOPRA,
      //   opacity: 'raster-opacity'
      // }
    ],
    locations: smartIceLocations
  },
  {
    name: 'BriggsIce',
    authId: 'BriggsIce',
    label: 'Briggs Ice',
    iconComponent: 'RiverIce',
    showCoordinates: true,
    data: [],
    datetimeUrls: [
    ],
    layers: [
      {
        name: 'BriggsIceDepth',
        label: 'Ice depth',
        url: SMART_ICE,
        opacity: 'circle-opacity'
      },
      {
        name: 'BriggsIceType',
        label: 'Ice type',
        url: SMART_ICE,
        opacity: 'fill-opacity'
      },
      {
        name: 'Sentinel2',
        label: 'Sentinel 2 (10 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis',
        url: MODIS,
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      }
    ],
    locations: [
      {
        name: 'Churchill River',
        latitude: 53.349444,
        longitude: -60.1775,
        maxBounds: [
          [-62.71154785156251, 51.11170321904176],
          [-58.09680175781251, 55.93314260987373]
        ],
        zoom: [7]
      }
    ]
  },
  {
    name: 'FloodMonitoring',
    authId: 'FloodMonitoring',
    label: 'Ice-Related Flood Hazard Exploits',
    iconComponent: 'RiverIce',
    showCoordinates: true,
    disableMainDate: true,
    data: [],
    datetimeUrls:[
    ],
    layers: [
      // {
      //   name: 'FloodRiverClassification',
      //   label: 'Ice classification',
      //   url: SMART_ICE,
      //   opacity: 'fill-opacity',
      //   legend: {
      //     type: 'categorical',
      //     data: legends.floodRiverClassificationLegend
      //   }
      // },
      {
        name: 'FloodHazard',
        label: 'Flood probability (%)',
        url: SMART_ICE,
        opacity: 'fill-opacity',
        open: true,
        datetimeId: 'FloodHazard',
        datetimeTransform: 'exploitsDatetime',
        legend: {
          type: 'categorical',
          data: legends.riverFloodMonitoringLegend,
          dx: 28
        }
      },
      {
        name: 'BadgerMask',
        label: 'Sentinel region',
        url: SMART_ICE,
        opacity: 'fill-opacity',
        hidden: true
      },
      {
        name: 'ExploitsMarkers',
        label: 'Kilometre markers',
        url: SMART_ICE,
        opacity: 'line-opacity'
      }
    ],
    locations: [
      {
        name: 'Exploits River',
        latitude: 48.9568,
        longitude: -56.0374,
        maxBounds: [
          [-65, 40],
          [-45, 60]
        ],
        zoom: [13]
      }
    ],
    disclaimers: ['The flood maps of the Exploits River cannot be used for any further decisions regarding flooding, flood mitigation, operations, evacuations, etc.']
  },
  {
    name: 'FloodMonitoringAthabasca',
    label: 'Ice-Related Flood Hazard Athabasca',
    iconComponent: 'RiverIce',
    weather: true,
    disableMainDate: true,
    minTime: new Date(2018, 0, 1).toISOString(),
    maxTime: new Date(2019, 0, 1).toISOString(),
    disclaimers: ['The flood maps of the Athabasca River cannot be used for any further decisions regarding flooding, flood mitigation, operations, evacuations, etc.'],
    data: [
    ],
    datetimeUrls: [
      {
        id: 'RiverIce',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:RiverIceAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
      }
    ],
    layers: [
      {
        name: 'RiverFloodMonitoring',
        label: 'Flood probability (%)',
        url: RIVER_ICE,
        opacity: 'fill-opacity',
        datetimeId: 'RiverFloodMonitoring',
        open: true,
        legend: {
          type: 'categorical',
          data: legends.riverFloodMonitoringLegend,
          dx: 28
        }
      },
      {
        name: 'RiverIceMarkers',
        label: 'Kilometre markers',
        url: RIVER_ICE_MARKERS,
        opacity: 'line-opacity'
      }
    ],
    locations: [
      {
        name: 'Athabasca River',
        extent: [[54.65, -114.2], [57.23, -111.08]],
        latitude: 56.7168,
        longitude: -111.3731,
        zoom: [12],
        maxBounds: [[-140.5, 53], [-110.0, 58]]
      },
      // {
      //   name: 'Churchill River',
      //   extent: [[54.65, -114.2], [57.23, -111.08]],
      //   latitude: 53.35,
      //   longitude: -60.18,
      //   zoom: [7],
      //   maxBounds: [[-80, 51], [-55, 68]]
      // }
    ]
  },
  // {
  //   name: 'PolarView',
  //   authId: 'SmartIce',
  //   label: 'Polar View',
  //   iconComponent: 'PolarView',
  //   weather: true,
  //   showCoordinates: true,
  //   data: [],
  //   datetimeUrls: [
  //     {
  //       id: 'SmartIce',
  //       url:
  //         'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceMapsAreaBounds&maxFeatures=50&outputFormat=application%2Fjson'
  //     },
  //     {
  //       id: 'SmartIceQamutik',
  //       url:
  //         'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:SmartIceQamutikAreaBounds&maxFeatures=50&outputFormat=application%2Fjson'
  //     },
  //     {
  //       id: 'Sentinel1',
  //       url:
  //         'https://services.sentinel-hub.com/ogc/wfs/6179cd9a-6ff5-43a5-8f01-8aef07e9f211?version=2.0.0&time=2017-12-16%2F2018-01-15&request=GetFeature&typeNames=DSS3&maxFeatures=100&outputFormat=application%2Fjson&maxcc=60&srsNAME=EPSG%3A4326&bbox=-90%2C-90%2C0%2C0&service=WFS',
  //       type: 'bbox'
  //     }
  //   ],
  //   layers: [
  //     {
  //       name: 'SmartIce',
  //       label: 'Ice travel',
  //       url: SMART_ICE,
  //       opacity: 'raster-opacity',
  //       datetimeId: 'SmartIce'
  //     },
  //     {
  //       name: 'Sentinel1',
  //       label: 'Sentinel 1 (75 m)',
  //       url: SENTINEL1,
  //       opacity: 'raster-opacity',
  //       datetimeId: 'Sentinel1',
  //       secondary: true
  //     },
  //     {
  //       name: 'Sentinel2',
  //       label: 'Sentinel 2 (10 m)',
  //       url: SENTINEL1,
  //       opacity: 'raster-opacity',
  //       datetimeId: 'Sentinel2',
  //       secondary: true
  //     },
  //     {
  //       name: 'Modis',
  //       label: 'Modis (250 m)',
  //       url: MODIS,
  //       opacity: 'raster-opacity',
  //       datetimeId: 'Modis',
  //       secondary: true
  //     },
  //     {
  //       name: 'CmemsSeaIce',
  //       label: 'Sea Ice Fraction',
  //       url: CMEMS_SEA_ICE,
  //       opacity: 'raster-opacity',
  //       datetimeId: 'CmemsSeaIce',
  //       secondary: true
  //     },
  //     {
  //       name: 'CmemsSnowThickness',
  //       label: 'Snow Thickness',
  //       url: CMEMS_SNOW_THICKNESS,
  //       opacity: 'raster-opacity',
  //       datetimeId: 'CmemsSnowThickness',
  //       secondary: true
  //     },
  //     {
  //       name: 'Coastline',
  //       label: 'Coastline',
  //       url: COASTLINE,
  //       opacity: 'raster-opacity'
  //     }
  //   ],
  //   locations: [
  //     {
  //       name: 'Clyde River',
  //       latitude: 70.35,
  //       longitude: -69.7,
  //       maxBounds: [[-78.5, 71], [-60.5, 69]],
  //       zoom: [7]
  //     },
  //     {
  //       name: 'Qaanaaq',

  //       latitude: 77.41,
  //       longitude: -69.79,
  //       maxBounds: [[-90, 72], [-51, 83]],
  //       zoom: [6]
  //     },
  //     {
  //       name: 'Utqiaġvik',
  //       latitude: 71.30783606806223,
  //       longitude: -156.785888671875,
  //       maxBounds: [[-175, 65], [-140, 76]],
  //       zoom: [6]
  //     }
  //   ]
  // },
  {
    name: 'RiverIce',
    label: 'River Ice',
    iconComponent: 'RiverIce',
    weather: true,
    disableMainDate: true,
    minTime: new Date(2018, 0, 1).toISOString(),
    maxTime: new Date(2019, 0, 1).toISOString(),
    data: [
      {
        id: 'RiverIcePoint',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaNormalized`,
        datetimeId: 'RiverIce',
        type: 'extent',
        active: 'RiverIcePointActive'
      },
      {
        id: 'RiverIce',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaNormalizedMV`,
        datetimeId: 'RiverIce',
        type: 'extent',
        active: 'active'
      }
    ],
    datetimeUrls: [
      {
        id: 'RiverIce',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:RiverIceAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
      }
    ],
    layers: [
      {
        name: 'RiverIce',
        label: 'Ice classification',
        url: RIVER_ICE,
        opacity: 'raster-opacity',
        datetimeId: 'RiverIce',
        open: true,
        legend: {
          type: 'categorical',
          data: legends.riverIceLegend
        }
      },
      // {
      //   name: 'Sentinel2Transparent',
      //   label: 'Sentinel 2',
      //   url: RIVER_ICE,
      //   opacity: 'raster-opacity',
      //   datetimeId: 'Sentinel2'
      // },
      {
        name: 'RiverIceMarkers',
        label: 'Kilometre markers',
        url: RIVER_ICE_MARKERS,
        opacity: 'line-opacity'
      }
    ],
    locations: [
      {
        name: 'Athabasca River',
        extent: [[54.65, -114.2], [57.23, -111.08]],
        latitude: 55.73,
        longitude: -112.38,
        zoom: [7],
        maxBounds: [[-140.5, 53], [-110.0, 58]]
      },
      // {
      //   name: 'Churchill River',
      //   extent: [[54.65, -114.2], [57.23, -111.08]],
      //   latitude: 53.35,
      //   longitude: -60.18,
      //   zoom: [7],
      //   maxBounds: [[-80, 51], [-55, 68]]
      // }
    ]
  },
  {
    name: 'RiverIceHistorical',
    label: 'River Ice Historical',
    iconComponent: 'RiverIce',
    weather: true,
    minTime: new Date(2017, 0, 1).toISOString(),
    maxTime: new Date(2018, 0, 1).toISOString(),
    data: [
      {
        id: 'RiverIcePoint',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaNormalized`,
        datetimeId: 'RiverIce',
        type: 'extent',
        active: 'RiverIcePointActive'
      },
      {
        id: 'RiverIce',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ARiverIceAreaNormalizedMV`,
        datetimeId: 'RiverIce',
        type: 'extent',
        active: 'active'
      }
    ],
    datetimeUrls: [
      {
        id: 'RiverIce',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:RiverIceAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
      }
    ],
    layers: [
      {
        name: 'RiverIce',
        url: RIVER_ICE,
        opacity: 'raster-opacity',
        datetimeId: 'RiverIce'
      },
      {
        name: 'RiverIceMarkers',
        url: RIVER_ICE_MARKERS,
        opacity: 'line-opacity'
      }
    ],
    locations: [
      {
        name: 'Athabasca River',
        extent: [[54.65, -114.2], [57.23, -111.08]],
        latitude: 55.73,
        longitude: -112.38,
        zoom: [7],
        maxBounds: [[-140.5, 53], [-110.0, 58]]
      },
      // {
      //   name: 'Churchill River',
      //   extent: [[54.65, -114.2], [57.23, -111.08]],
      //   latitude: 53.35,
      //   longitude: -60.18,
      //   zoom: [7],
      //   maxBounds: [[-80, 51], [-55, 68]]
      // }
    ]
  },
  // {
  //   name: 'RiverIceVector',
  //   layers: [
  //     {
  //       name: 'RiverIceVector',
  //       url: RIVER_ICE_VECTOR,
  //       opacity: 'raster-opacity'
  //     }
  //   ],
  //   locations: [
  //     {
  //       name: 'Ft. McMurray',
  //       latitude: 56.73,
  //       longitude: -111.38,
  //       zoom: [10]
  //     }
  //   ]
  // },
  {
    name: 'LandDeformation',
    label: 'Land Deformation',
    iconComponent: 'LandDeformation',
    showCoordinates: true,
    data: [
      {
        id: 'LandDeformationCalifornia',
        type: 'point',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AQueryLandDeformationCalifornia'
      }
    ],
    layers: [
      {
        name: 'LandDeformationInsar',
        label: 'Land Deformation',
        url: LAND_DEFORMATION,
        opacity: 'raster-opacity',
        datetimeId: 'LandDeformationInsar',
        disableToggle: true,
        legend: {
          type: 'categorical',
          data: legends.deformationLegend
        }
      }
    ],
    locations: [
      {
        name: 'Buttonwillow',
        latitude: 35.3,
        longitude: -119.6,
        zoom: [10],
        maxBounds: [[-120, 34], [-118, 36]]
      }
    ]
  },
  {
    name: 'InlandWaters',
    label: 'Water Monitoring',
    authId: 'WaterSediment',
    iconComponent: 'InlandWaters',
    hideDatetimeSlider: true,
    data: [
      {
        id: 'WaterTemperature',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AWaterTemperaturePointChartData`,
        datetimeId: 'WaterTemperature',
        type: 'point'
      },
      {
        id: 'WaterSediment',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AWaterSedimentPointChartData`,
        datetimeId: 'WaterSediment',
        type: 'point'
      },
      {
        id: 'WaterLakeTss',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AWaterLakeTssPointData`,
        datetimeId: 'WaterLakeTss',
        type: 'point'
      },
      {
        id: 'WaterLakeChl',
        url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AWaterLakeChlPointData`,
        datetimeId: 'WaterLakeChl',
        type: 'point'
      }
    ],
    layers: [
      {
        name: 'WaterTemperature',
        label: 'River Temperature (°C, 30m)',
        url: MOPRA,
        opacity: 'raster-opacity',
        datetimeId: 'WaterTemperature',
        legend: {
          type: 'categorical',
          data: legends.riverTemperatureLegend
        }
      },
      {
        name: 'WaterSediment',
        label: 'River Sediment (mg/L, 30m)',
        url: MOPRA,
        opacity: 'raster-opacity',
        datetimeId: 'WaterSediment',
        legend: {
          type: 'categorical',
          data: legends.riverSedimentLegend
        }
      },
      // {
      //   name: 'WaterRiverSsc',
      //   label: 'River Sediment (10m)',
      //   url: WATER_RIVER_SSC,
      //   opacity: 'raster-opacity',
      //   datetimeId: 'WaterRiverSsc'
      // },
      {
        name: 'WaterLakeTss',
        label: 'Lake TSS (mg/L, 300m)',
        url: WATER_LAKE_TSS,
        opacity: 'raster-opacity',
        datetimeId: 'WaterLakeTss',
        legend: {
          type: 'categorical',
          data: legends.waterLakeTssLegend
        }
      },
      {
        name: 'WaterLakeChl',
        label: 'Lake Chl-a (ng/L, 300m)',
        url: WATER_LAKE_CHL,
        opacity: 'raster-opacity',
        datetimeId: 'WaterLakeChl',
        legend: {
          type: 'categorical',
          data: legends.waterLakeChlLegend
        }
      },
      // {
      //   name: 'WaterLakeTssVector',
      //   label: 'Lake TSS Vector',
      //   url: WATER_LAKE_TSS_VECTOR,
      //   opacity: 'fill-opacity'
      //   // datetimeId: 'WaterLakeTss'
      // },
      // {
      //   name: 'WaterLakeTssHeat',
      //   label: 'Lake TSS Heatmap',
      //   url: LAKE_TSS_VECTOR,
      //   opacity: 'fill-opacity'
      //   // datetimeId: 'WaterLakeTss'
      // },
      {
        name: 'Sentinel1',
        label: 'Sentinel 1 (75 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1'
      },
      {
        name: 'Sentinel2',
        label: 'Sentinel 2 (10 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2'
      },
      {
        name: 'Modis',
        label: 'Modis (250 m)',
        url: MODIS,
        opacity: 'raster-opacity'
        // datetimeId: 'Modis'
      }
    ],
    locations: [
      {
        name: 'GreatSlaveLake',
        label: 'Great Slave Lake',
        latitude: 61.667,
        longitude: -114,
        maxBounds: [[-120.5, 58], [-110, 63]],
        zoom: [7]
      },
      {
        name: 'SlaveRiver',
        label: 'Slave River',
        latitude: 60.828,
        longitude: -113.259,
        maxBounds: [[-120, 58], [-110, 63]],
        zoom: [12]
      }
    ]
  },
  {
    name: 'Pipeline',
    label: 'Pipeline',
    permissionId: 'pipeline',
    iconComponent: 'Pipeline',
    showCoordinates: true,
    data: [],
    layers: [
      {
        name: 'PipelineGreen',
        label: 'Pipeline Green',
        url: ICE_DRIFT,
        opacity: 'raster-opacity',
        datetimeId: 'PipelineGreen',
        legend: {
          type: 'categorical',
          data: legends.pipelineGreenLegend
        }
      }
    ],
    locations: [
      {
        name: 'MackinawCity',
        label: 'Mackinaw City',
        latitude: 45.783889,
        longitude: -84.7278,
        maxBounds: [[-150, -85], [80, 85]],
        zoom: [10]
      },
      {
        name: 'Quebec',
        label: 'Quebec',
        latitude: 48.282,
        longitude: -72.186,
        maxBounds: [[-150, -85], [80, 85]],
        zoom: [10]
      }
    ]
  },
  {
    name: 'IceDrift',
    label: 'Ice Drift',
    permissionId: 'iceDrift',
    iconComponent: 'SmartIce',
    showCoordinates: true,
    data: [],
    layers: [
      {
        name: 'IceDrift',
        label: 'Ice Drift',
        url: ICE_DRIFT,
        opacity: 'raster-opacity',
        datetimeId: 'IceDrift'
      },
      {
        name: 'IceDriftVelocity',
        label: 'Ice Velocity',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftVelocity'
      },
      {
        name: 'IceDriftDeformation',
        label: 'Ice Deformation',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformation'
      },
      {
        name: 'IceDriftDirection',
        label: 'Ice Direction',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDirection'
      },
      {
        name: 'IceDriftMagnitude',
        label: 'Ice Magnitude',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftMagnitude'
      },
      {
        name: 'IceDriftDeformationShear',
        label: 'Ice Deformation Shear',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformationShear'
      },
      {
        name: 'Sentinel1SixMonth',
        label: 'Sentinel 1 (75 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1SixMonth',
        secondary: true
      },
      {
        name: 'Sentinel2SixMonth',
        label: 'Sentinel 2 (10 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2SixMonth',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis (250 m)',
        url: MODIS,
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      }
    ],
    locations: [
      {
        name: 'IceDrift',
        label: 'Ice Drifit',
        latitude: 72.72476,
        longitude: -74.6495,
        zoom: [6]
      }
    ]
  },
  {
    name: 'IceDriftDev',
    label: 'Ice Drift Dev',
    permissionId: 'iceDriftDev',
    iconComponent: 'SmartIce',
    showCoordinates: true,
    data: [],
    layers: [
      {
        name: 'IceDrift',
        label: 'Ice Drift',
        url: ICE_DRIFT,
        opacity: 'raster-opacity',
        datetimeId: 'IceDrift'
      },
      {
        name: 'IceDriftVelocity',
        label: 'Ice Velocity',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftVelocity'
      },
      {
        name: 'IceDriftDeformation',
        label: 'Ice Deformation',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformation'
      },
      {
        name: 'IceDriftDirection',
        label: 'Ice Direction',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDirection'
      },
      {
        name: 'IceDriftMagnitude',
        label: 'Ice Magnitude',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftMagnitude'
      },
      {
        name: 'IceDriftDeformationShear',
        label: 'Ice Deformation Shear',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformationShear'
      },
      {
        name: 'IceDriftDeformationVorticity',
        label: 'Ice Deformation Vorticity',
        url: ICE_DRIFT_VELOCITY,
        opacity: 'raster-opacity',
        datetimeId: 'IceDriftDeformationVorticity'
      },
      {
        name: 'Sentinel1SixMonth',
        label: 'Sentinel 1 (75 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1SixMonth',
        secondary: true
      },
      {
        name: 'Sentinel2SixMonth',
        label: 'Sentinel 2 (10 m)',
        url: SENTINEL1,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2SixMonth',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis (250 m)',
        url: MODIS,
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      }
    ],
    locations: [
      {
        name: 'IceDrift',
        label: 'Ice Drifit',
        latitude: 72.72476,
        longitude: -74.6495,
        zoom: [6]
      }
    ]
  },
  {
    name: 'LeakDetection',
    label: 'Leak Detection',
    permissionId: 'LeakDetection',
    iconComponent: 'LeakDetection',
    showCoordinates: true,
    data: [
      {
        id: 'LeakDetectionPoint',
        type: 'point',
        url:
        'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3ALeakDetectionPoint'
      }
    ],
    layers: [
      {
        name: 'LeakDetection',
        label: 'Leak Detection',
        url: ICE_DRIFT,
        opacity: 'fill-opacity',
        filter: ['>', 'value', 70],
        legend: {
          type: 'categorical',
          data: legends.leakDetectionLegend
        },
        datetimeId: 'LeakDetection'
      },
      {
        name: 'Sentinel2LeakDetection',
        label: 'Real-time basemap',
        url: RIVER_ICE,
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2LeakDetection',
        secondary: true
      }
    ],
    locations: [
      {
        name: 'LomPangarDam',
        label: 'Lom Pangar Dam, Cameroon',
        latitude: 5.371353,
        longitude: 13.512408,
        zoom: [10]
      },
      {
        name: 'YellowheadCounty',
        label: 'Yellowhead County, Alberta',
        latitude: 53.96,
        longitude: -117.36,
        zoom: [10]
      }
    ]
  }
]

export default services



// WEBPACK FOOTER //
// ./src/config/services.js